import React from "react";
import classNames from "classnames";

import { Checkbox } from "@common/checkbox";
import { ZoneAvatar } from "@common/zoneAvatar";
import { Props } from "./types";
import styles from "./styles.scss";

function DestinationsList(props: Props) {
  return (
    <ul className={styles.zonesList}>
      {props.zones.map((zone) => (
        <li
          key={zone.uuid}
          className={classNames(styles.item, {
            [styles.selectedItems]:
              !!props.selectedZone && zone.uuid === props.selectedZone.uuid,
          })}
        >
          <label
            className={styles.label}
            onClick={() => props.selectZone(zone)}
          >
            <Checkbox
              isChecked={
                !!props.selectedZone && zone.uuid === props.selectedZone.uuid
              }
            />
            <div className={styles.zone}>
              <div className={styles.avatar}>
                <ZoneAvatar {...zone} />
              </div>
              <span>{zone.name}</span>
            </div>
          </label>
        </li>
      ))}
    </ul>
  );
}

export { DestinationsList };
